export default "__VITE_ASSET__BHXARDB___"